import React, { Component } from 'react'
import PropTypes from 'prop-types'
import pluralize from 'pluralize'
import { connect } from 'react-redux'

import getEntityByIdSelector from '../selectors/getEntityById'

import ContentDisplay from './ContentDisplay'
import InteractiveElement from './InteractiveElement'

class Section extends Component {
  render () {
    const {
      section,
      data,
      history
    } = this.props

    const {
      sectionContentType
    } = section

    if (sectionContentType === 'ContentDisplay') {
      return <ContentDisplay content={data.content} contentDisplayType={data.contentDisplayType} />
    }

    if (sectionContentType === 'InteractiveElement') {
      return <InteractiveElement data={data} history={history} />
    }

    return null
  }
}

Section.propTypes = {
  section: PropTypes.object,
  data: PropTypes.object,
  history: PropTypes.object
}

const mapStateToProps = (state, ownProps) => {
  const {
    sectionContentType,
    sectionContentId
  } = ownProps.section

  const contentType = pluralize(sectionContentType.toLowerCase())

  return {
    data: getEntityByIdSelector(state, contentType, sectionContentId)
  }
}

export default connect(mapStateToProps)(Section)



// WEBPACK FOOTER //
// ./src/components/Section.js